/* eslint-disable no-undef, react/prop-types */
import React from 'react';
import { css } from 'react-emotion';
import Link from 'gatsby-link';
import { Box } from '../components/Layout';
import colors from '../utils/colors';

const style = css`
  text-align: center;
  padding-bottom: 10%;
  & ul {
    list-style-type: none;
    color: ${colors.primary};
  }
  h1,
  h2 {
    padding-bottom: 0.5em;
  }
  h2 {
    padding-top: 1em;
  }
  }
`;

const linkStyle = css`
  color: ${colors.primary};
  text-decoration: underline;
  &:hover {
    text-decoration: none;
  }
`;

const English = () => (
  <Box>
    <Box
      className={style}
      width={[1, 1, 1 / 2]}
      m={['3.5rem 0 0 0', '3.5rem 0 0 0', '3.5rem auto 0 auto']}
      px={[3, 3, 0]}
      color={colors.secondary}
    >
      <h1>Owla and the Hidden Hearth</h1>
      <p>
        Owla and the Hidden Hearth is a thrilling adventure that combines the
        magic of fairy tales with elements from Finnish folklore and the local
        history of Oulu. More than 90 performers – professional dancers, amateur
        folk dancers, and musicians – lead you from the alleys and parks of Owla
        to the far corners of this mystical world. In the city of Owla you will
        meet charming characters, see skillful dancing, and hear beautiful
        music.
      </p>

      <h2>Performances</h2>
      <ul>
        <li>Wednesday 6th of June, 7:00 pm</li>
        <li>Thursday 7th of June, 6:00 pm</li>
        <li>Friday 8th of June, 6:00 pm</li>
        <li>Saturday 9th of June, 2:00 pm</li>
        <li>Saturday 9th of June, 6:00 pm</li>
        <li>Sunday 10th of June, 1:00 pm</li>
      </ul>
      <h2>Location</h2>
      <p>
        Valvesali<br />
        Kulttuuritalo Valve<br />
        Hallituskatu 7, 90100 Oulu<br />
        Running time: 1 hour 50 minutes inc. interval
      </p>

      <h2>Tickets</h2>
      <p>15€ / 10€ for children under 10</p>
      <br />
      <p>
        Kulttuuritalo Valve Ticket Shop<br />
        Hallituskatu 7, Oulu<br />
        Open Wed–Sun 12–19,<br />
        tel. (08) 5584 7575<br />
        (No service fee)
      </p>
      <br />
      <Link
        className={linkStyle}
        href="https://www.ticketmaster.fi/search/?keyword=owla+ja+kadonnut+walkia"
        target="_blank"
        rel="noopener"
      >
        Ticketmaster.fi
      </Link>
      <p>(Ticketmaster outlets in Finland collect their own service fees)</p>

      <h2>Inquiries</h2>
      <p>
        Hanna Poikela,{' '}
        <a href="mailto:hanna.poikela@gmail.com">hanna.poikela@gmail.com</a>
      </p>
    </Box>
  </Box>
);

export default English;



// WEBPACK FOOTER //
// ./src/pages/english.js